import { Route, State } from 'router5';
import { IStore } from './store/Store';

// Constants
import { ROUTE_NAMES, ROUTE_PATHS } from './constants/routes';

export type LifecycleHandler = (
  toState: State,
  fromState: State,
  done: (parameter?: object) => void
) => void;

const routes: Array<Route> = [
  {
    name: ROUTE_NAMES.LOGIN,
    path: '/login'
  },
  {
    name: ROUTE_NAMES.SIGNUP,
    path: '/signup'
  },
  {
    name: ROUTE_NAMES.FORGOT,
    path: '/forgot'
  },
  {
    name: ROUTE_NAMES.RESET,
    path: '/reset?secret&id'
  },
  {
    name: ROUTE_NAMES.APP,
    path: '/',
    canActivate: (router, dependencies) => (toState, fromState, done) => {
      if (dependencies) {
        if ((dependencies.store as IStore).meStore.hasToken) {
          done();
          return true;
        } else {
          done({ redirect: { name: ROUTE_PATHS.LOGIN } });
          return false;
        }
      } else {
        done({ redirect: { name: ROUTE_PATHS.LOGIN } });
        return false;
      }
    },
    children: [
      {
        name: ROUTE_NAMES.APP_INTRO,
        path: 'intro'
      },
      {
        name: 'notifications_redirect',
        path: 'notifications',
        forwardTo: ROUTE_PATHS.APP
      },
      {
        name: ROUTE_NAMES.APP_NETWORK,
        path: 'networks/:networkId',
        forwardTo: ROUTE_PATHS.APP_NETWORK_HOME,
        children: [
          {
            name: ROUTE_NAMES.APP_NETWORK_NOTIFICATIONS,
            path: '/notifications'
          },
          {
            name: ROUTE_NAMES.APP_NETWORK_HOME,
            path: '/home'
          },
          {
            name: ROUTE_NAMES.APP_NETWORK_PEOPLE,
            path: '/people',
            forwardTo: ROUTE_PATHS.APP_NETWORK_PEOPLE_SEARCH,
            children: [
              {
                name: ROUTE_NAMES.APP_NETWORK_PEOPLE_SEARCH,
                path: '/search'
              },
              {
                name: ROUTE_NAMES.APP_NETWORK_PEOPLE_STATISTICS,
                path: '/statistics'
              },
              {
                name: ROUTE_NAMES.APP_NETWORK_PEOPLE_MYTAGS,
                path: '/my-tags'
              }
            ]
          },
          {
            name: ROUTE_NAMES.APP_NETWORK_QUESTIONS,
            path: '/questions'
          },
          {
            name: ROUTE_NAMES.APP_NETWORK_ADMINISTRATION,
            path: '/administration',
            forwardTo: ROUTE_PATHS.APP_NETWORK_ADMINISTRATION_DETAILS,
            children: [
              {
                name: ROUTE_NAMES.APP_NETWORK_ADMINISTRATION_DETAILS,
                path: '/details'
              },
              {
                name: ROUTE_NAMES.APP_NETWORK_ADMINISTRATION_TAG_MANAGER,
                path: '/tag-manager'
              },
              {
                name: ROUTE_NAMES.APP_NETWORK_ADMINISTRATION_MEMBERS,
                path: '/members'
              }
            ]
          }
        ]
      }
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes.ts